import React, { useCallback, forwardRef, useImperativeHandle, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Text } from '@weareconceptstudio/core';
import classNames from 'classnames';
const BaseForm = forwardRef(({ initialValues: defaultValues, values, children, onSubmit, mode = 'onBlur', reValidateMode = 'onChange', errors, resetOptions, criteriaMode = 'firstError', shouldFocusError, delayError = 0, shouldUseNativeValidation, shouldUnregister, className, }, ref) => {
    const methods = useForm({
        mode,
        errors,
        values,
        delayError,
        resetOptions,
        criteriaMode,
        // @ts-ignore
        defaultValues,
        reValidateMode,
        shouldFocusError,
        shouldUnregister,
        shouldUseNativeValidation,
    });
    const handleSubmit = useCallback(async (values) => {
        return await onSubmit(values)?.catch(({ data, status }) => {
            if (status === 422) {
                for (const key in data.errors) {
                    if (data.errors.hasOwnProperty(key)) {
                        // @ts-ignore
                        methods.setError(key, {
                            type: 'manual',
                            message: data.errors[key][0],
                        });
                    }
                }
            }
            else {
                methods.setError('root.serverError', {
                    type: String(status),
                    message: data?.message || 'form.serverError',
                });
            }
        });
    }, [methods, onSubmit]);
    useImperativeHandle(ref, () => ({
        ...methods,
        isValid: methods.formState.isValid,
        isFormTouched: Object.keys(methods.formState.touchedFields).length > 0,
        submit: () => methods.handleSubmit(handleSubmit)(),
    }));
    useEffect(() => {
        if (methods.formState.isSubmitted && Object.keys(methods.formState.errors).length > 0) {
            const errors = methods.formState.errors;
            const firstErrorField = Object.keys(errors)[0];
            const errorElement = document.querySelector(`[name="${firstErrorField}"]`);
            if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                try {
                    // @ts-ignore
                    errors[firstErrorField].ref?.focus();
                }
                catch (e) { }
            }
        }
    }, [methods.formState.isSubmitted, methods.formState.errors]);
    return (React.createElement(FormProvider, { ...methods },
        methods.formState.errors.root?.serverError && (React.createElement("div", { className: 'global-error-wrap' },
            React.createElement(Text, { className: 'backend-error', text: methods.formState.errors.root?.serverError.message }),
            React.createElement(Text, { className: 'frontend-error', text: 'form.globalError' }))),
        React.createElement("form", { onSubmit: methods.handleSubmit(handleSubmit), className: classNames({
                [className]: !!className,
            }) }, children)));
});
if (process.env.NODE_ENV !== 'production') {
    BaseForm.displayName = 'BaseForm';
}
export default BaseForm;
//# sourceMappingURL=BaseForm.js.map